<template>
    <div ref="parent" class="text v--15" :class="`text--${instance.class}`">
        <!--{{instance}}-->
        <h2 v-if="instance.title" v-html="instance.title" ref="title" class="text__title type--h2" :class="instance.title_icon ? instance.title_icon : ''"></h2>
        <div v-if="instance.include_urge_surfing" class="urge-surfing">
            <Icon name="urge-surfing-5"/>
        </div>
        <div v-if="instance.content" v-html="instance.content" ref="content" class="text__content type--content-styles type--content-margins type--content-links"></div>
    </div>
</template>

<script>
import { gsap } from "gsap";
import Icon from "@c/Icon.vue"
export default {
    data() {
        return {
            tl: null,
        }
    },
    components: {
        Icon,
    },
    props: {
        instance: Object,
        active: Boolean,
    },
    computed: {
        pageBuildItems() {
            return this.$refs.content.querySelectorAll('p, li, h1, h2, h3, h4, h5, h6');
        }
    },
    watch: {
        // Fired if we're coming from another page
        active() {
            if (this.active === true) {
                console.log('this page is now active!');
                if (this.instance.page_build === true) {
                    this.$nextTick(() => {
                        console.log('doing page build on active');
                        this.doPageBuild();
                    });
                }
            }
            if (this.active === false && this.tl !== null) {
                this.tl.kill();
                this.tl = null;
            }
        }
    },
    // Fired if we're loading into this page directly
    mounted() {
        if (this.active === true) {
            if (this.instance.page_build === true) {
                this.$nextTick(() => {
                    console.log('doing page build on mount');
                    this.doPageBuild();
                });
                
            }
        }
    },
    methods: {
        hidePageBuildItems() {
            this.pageBuildItems.forEach(function(item) {
                item.style.opacity = 0;
                item.style.transform = 'TranslateY(20px)';
            });
        },
        doPageBuild() {
            console.log('i am currently doing a page build function');

            this.hidePageBuildItems();

            this.tl = gsap.timeline();

            this.tl.fromTo(this.pageBuildItems,
                {
                    opacity: 0,
                    y: 20
                },
                {
                    opacity: 1,
                    y: 0,
                    stagger: 1.50,
                    duration: 0.45,
                    delay: 0.45,
                    ease: "power3.out"
                },
                "1"
            );
        },
    },
}
</script>

<style lang="scss">
@import "@s/_mixins.scss";
@import "@s/_vars.scss";

$icon_tasks: '<svg xmlns="http://www.w3.org/2000/svg" width="22.944" height="18" viewBox="0 0 22.944 18"><defs><clipPath id="icon-tools-task-a"><path d="M2.44 0c.648 0 1.268.238 1.726.66.457.422.715.993.715 1.59 0 .597-.257 1.169-.715 1.591a2.55 2.55 0 0 1-1.725.659 2.55 2.55 0 0 1-1.726-.659A2.165 2.165 0 0 1 0 2.25C0 1.653.257 1.081.715.659A2.55 2.55 0 0 1 2.44 0Zm0 1.373a.993.993 0 0 0-.672.257.843.843 0 0 0-.278.62c0 .233.1.455.278.62.179.164.42.257.673.257a.994.994 0 0 0 .672-.257.844.844 0 0 0 .279-.62c0-.232-.1-.455-.279-.62a.994.994 0 0 0-.672-.257Z"/></clipPath><clipPath id="icon-tools-task-b"><path d="M15.058 0c.25 0 .49.086.666.241A.775.775 0 0 1 16 .824c0 .219-.1.428-.276.583a1.013 1.013 0 0 1-.666.24H.942c-.25.001-.49-.086-.666-.24A.775.775 0 0 1 0 .824C0 .605.1.396.276.24.453.086.692 0 .942 0Z"/></clipPath><clipPath id="icon-tools-task-c"><path d="M2.44 0c.648 0 1.268.238 1.726.66.457.422.715.993.715 1.59 0 .597-.257 1.169-.715 1.591a2.55 2.55 0 0 1-1.725.659 2.55 2.55 0 0 1-1.726-.659A2.165 2.165 0 0 1 0 2.25C0 1.653.257 1.081.715.659A2.55 2.55 0 0 1 2.44 0Zm0 1.373a.993.993 0 0 0-.672.257.843.843 0 0 0-.278.62c0 .233.1.455.278.62.179.164.42.257.673.257a.994.994 0 0 0 .672-.257.844.844 0 0 0 .279-.62c0-.232-.1-.455-.279-.62a.994.994 0 0 0-.672-.257Z"/></clipPath><clipPath id="icon-tools-task-d"><path d="M15.058 0c.25 0 .49.086.666.241A.775.775 0 0 1 16 .824c0 .219-.1.428-.276.583a1.013 1.013 0 0 1-.666.24H.942c-.25.001-.49-.086-.666-.24A.775.775 0 0 1 0 .824C0 .605.1.396.276.24.453.086.692 0 .942 0Z"/></clipPath><clipPath id="icon-tools-task-e"><path d="M2.44 0c.648 0 1.268.238 1.726.66.457.422.715.993.715 1.59 0 .597-.257 1.169-.715 1.591a2.55 2.55 0 0 1-1.725.659 2.55 2.55 0 0 1-1.726-.659A2.165 2.165 0 0 1 0 2.25C0 1.653.257 1.081.715.659A2.55 2.55 0 0 1 2.44 0Zm0 1.373a.993.993 0 0 0-.672.257.843.843 0 0 0-.278.62c0 .233.1.455.278.62.179.164.42.257.673.257a.994.994 0 0 0 .672-.257.844.844 0 0 0 .279-.62c0-.232-.1-.455-.279-.62a.994.994 0 0 0-.672-.257Z"/></clipPath><clipPath id="icon-tools-task-f"><path d="M15.058 0c.25 0 .49.086.666.241A.775.775 0 0 1 16 .824c0 .219-.1.428-.276.583a1.013 1.013 0 0 1-.666.24H.942c-.25.001-.49-.086-.666-.24A.775.775 0 0 1 0 .824C0 .605.1.396.276.24.453.086.692 0 .942 0Z"/></clipPath></defs><g clip-path="url(#icon-tools-task-a)"><path fill="#5c2fc8" d="M0 0h4.881v4.5H0V0z"/></g><g clip-path="url(#icon-tools-task-b)" transform="translate(6.944 1.458)"><path fill="#5c2fc8" d="M0 0h16v1.648H0V0z"/></g><g clip-path="url(#icon-tools-task-c)" transform="translate(0 6.75)"><path fill="#5c2fc8" d="M0 0h4.881v4.5H0V0z"/></g><g clip-path="url(#icon-tools-task-d)" transform="translate(6.944 8.208)"><path fill="#5c2fc8" d="M0 0h16v1.648H0V0z"/></g><g><g clip-path="url(#icon-tools-task-e)" transform="translate(0 13.5)"><path fill="#5c2fc8" d="M0 0h4.881v4.5H0V0z"/></g><g clip-path="url(#icon-tools-task-f)" transform="translate(6.944 14.958)"><path fill="#5c2fc8" d="M0 0h16v1.648H0V0z"/></g></g></svg>';
$icon_plan: '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="22.414" viewBox="0 0 25 22.414"><defs><clipPath id="icon-tools-plan-a"><path d="M15.151 16.38a1.168 1.168 0 0 1 .837 1.994l-1 1.011 1.013.999a1.168 1.168 0 0 1-.498 1.992 1.174 1.174 0 0 1-1.15-.33l-1.005-.999-1.003 1.012c-.187.19-.433.31-.696.34l-.133.008a1.168 1.168 0 0 1-.832-1.992l1.001-1.011-1.022-1.004a1.168 1.168 0 0 1 .02-1.624 1.174 1.174 0 0 1 1.628-.038l1.013 1 1-1.01c.188-.19.433-.31.695-.34l.132-.009ZM14.536.41a1.045 1.045 0 0 1 1.525-.146l2.54 2.23c.438.409.488 1.11.114 1.584a1.045 1.045 0 0 1-1.498.17l-.53-.466c.452 4.95-2.472 9.684-6.886 11.088a9.292 9.292 0 0 1-3.385.425l-.025.051a3.415 3.415 0 0 1-2.004 1.738 3.22 3.22 0 0 1-2.592-.265c-1.21-.68-1.912-2.061-1.779-3.5.133-1.438 1.074-2.65 2.386-3.072a3.23 3.23 0 0 1 2.752.365 3.572 3.572 0 0 1 1.566 2.415 7.26 7.26 0 0 0 2.44-.34c3.489-1.106 5.764-4.819 5.379-8.712l-.454.573a1.045 1.045 0 0 1-1.524.147 1.185 1.185 0 0 1-.139-1.607ZM3.516 12.07l-.155.001c-.14.008-.279.032-.413.073-.444.13-.817.433-1.035.841l.01.003a1.724 1.724 0 1 0 1.438-.917Zm20.258-3.45a1.17 1.17 0 0 1 .832 1.996l-.998 1.013 1.014.992a1.173 1.173 0 0 1-.497 1.996 1.17 1.17 0 0 1-1.147-.33l-1.01-1.003-1.002 1.013c-.187.19-.432.31-.695.34l-.132.008a1.17 1.17 0 0 1-.836-1.995l1-1.013-1.01-.992a1.173 1.173 0 0 1 .02-1.627 1.17 1.17 0 0 1 1.624-.038l1.013 1.002.999-1.013c.186-.19.43-.31.693-.34l.132-.008ZM9.352 1.759a1.146 1.146 0 0 1 .512 1.952l-.985.994.998.981a1.147 1.147 0 0 1-.426 2.044 1.157 1.157 0 0 1-1.172-.415l-.998-.981-.986.994a1.16 1.16 0 0 1-1.636.02 1.149 1.149 0 0 1-.02-1.63l.99-.992-.99-.986a1.146 1.146 0 0 1 .02-1.596 1.158 1.158 0 0 1 1.603-.038l.977.984.985-.994c.286-.31.719-.438 1.128-.337Z"/></clipPath></defs><g clip-path="url(#icon-tools-plan-a)"><path fill="#5c2fc8" d="M0 0h25v22.414H0V0z"/></g></svg>';
$icon_help: '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"><defs><clipPath id="icon-tools-help-a"><path d="M11 0c6.067 0 11 4.933 11 11s-4.933 11-11 11S0 17.067 0 11 4.933 0 11 0Zm0 2.015c-4.956 0-8.985 4.03-8.985 8.985 0 4.956 4.03 8.985 8.985 8.985 4.956 0 8.985-4.03 8.985-8.985 0-4.956-4.03-8.985-8.985-8.985Z"/></clipPath><clipPath id="icon-tools-help-b"><path d="M1.435 0C2.226 0 2.87.559 2.87 1.247v5.158c0 .688-.644 1.247-1.435 1.247C.643 7.652 0 7.093 0 6.405V1.247C0 .559.643 0 1.435 0Z"/></clipPath><clipPath id="icon-tools-help-c"><path d="M1.435 0a1.435 1.435 0 1 1 0 2.87 1.435 1.435 0 0 1 0-2.87Z"/></clipPath></defs><g clip-path="url(#icon-tools-help-a)"><path fill="#5c2fc8" d="M0 0h22v22H0V0z"/></g><g clip-path="url(#icon-tools-help-b)" transform="translate(9.565 4.783)"><path fill="#5c2fc8" d="M0 0h2.87v7.652H0V0z"/></g><g clip-path="url(#icon-tools-help-c)" transform="translate(9.565 14.348)"><path fill="#5c2fc8" d="M0 0h2.87v2.87H0V0z"/></g></svg>';
$icon_bonus: '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"><path fill="#755AD8" fill-rule="nonzero" stroke="none" stroke-width="1" d="m.495 10.027 5.22 3.81-2.108 6.579c-.158.496.011 1.04.421 1.35a1.16 1.16 0 0 0 1.382.01L11 17.695l5.59 4.081c.416.303.972.298 1.382-.011.41-.31.58-.854.42-1.35l-2.106-6.579 5.219-3.81c.417-.305.595-.851.437-1.352a1.18 1.18 0 0 0-1.12-.84h-6.46L12.12.831A1.182 1.182 0 0 0 11.001 0c-.51 0-.96.335-1.12.831L7.64 7.834h-6.46c-.513 0-.967.34-1.123.84a1.226 1.226 0 0 0 .439 1.353Z"/></svg>';

.text--session-preview {
    .type--content-styles {
        ol li, ul li, p {
            font-size: rem(20px);
            line-height: lh(20px, 26px);
            letter-spacing: 0.26px;
        }
    }
}
.urge-surfing {
    svg {
        width:100%;
        height: auto;
        #us-line {
            fill: none;
            stroke-width: 7px;
            stroke: #BF4AC0;
            stroke-dasharray: 1400;
            stroke-dashoffset: 0;
            animation: dash 8s linear;
            animation-iteration-count: 1;
        }
    }
}

@keyframes dash {
    0% {
        stroke-dashoffset: 1450;
    }
    100% {
        stroke-dashoffset: 0;
    }
}

.text__title {
    &.icon {
        display: flex;
        align-items: center;
        &:before {
            content: "";
            display: inline-block;
            margin-right: rem(10px);
            background-repeat: no-repeat;
            background-position: top left;
        }
        &--help {
            &:before {
                width: rem(22px);
                height: rem(22px);
                background-image: svg-url($icon_help);
            }
        }
        &--tasks {
            &:before {
                width: rem(23px);
                height: rem(18px);
                background-image: svg-url($icon_tasks);
            }
        }
        &--plan {
            &:before {
                width: rem(25px);
                height: rem(23px);
                background-image: svg-url($icon_plan);
            }
        }
        &--bonus {
            &:before {
                width: rem(22px);
                height: rem(22px);
                background-image: svg-url($icon_bonus);
            }
        }
    }
}
</style>